export default __webpack_public_path__ + "static/app-features-6--mobile-5640575ea221f5fed8cf95d4f671d533.webp";